import { SxProps } from '@mui/material';

export const RegistrationTextFieldSX: SxProps = {
	'.MuiOutlinedInput-notchedOutline': {
		border: '1px solid #C9C9C9',
		borderRadius: '6px',
	},
	'& .MuiOutlinedInput-root': {
		'&:hover fieldset': {
			borderColor: '#C9C9C9',
		},
		'&.Mui-focused fieldset': {
			borderColor: '#774A91',
		},
	},
};
